// extracted by mini-css-extract-plugin
export var checkList_column = "CheckList-module--checkList_column--7defb";
export var checkList_wrap = "CheckList-module--checkList_wrap--97e76";